import main from './note';
export default main;